const globalPrefix = makeRandomValue(8);
let globalCounter = 0;
function makeRandomValue(length = 8) {
  let str = '';
  while (str.length < length) {
    str += (~~(Math.random() * 1e9)).toString(36);
  }
  return str.slice(0, length);
}

/**
 * 其实不是 uuidv4 算法，但是反正是字符串就对了。性能比 uuidv4 好很多
 */
export default function uuidv4() {
  globalCounter += 1;
  return `${globalPrefix}-${globalCounter.toString(36)}-${makeRandomValue(8)}`;
}